import { handleActions } from 'redux-actions';
import { stateUpdate, clearError, State } from './action';

const initialState: State = {
  commissionShares: [],
  loading: false,
  error: null,
  pagination: undefined,
};

const reducer = handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(clearError)]: (state) => {
      return {
        ...state,
        error: null,
      };
    },
  },

  initialState,
);

export default reducer;
